/**
 * Pure helpers used by the home bootstrap populator. Designed as
 * branch-agnostic primitives so a second consumer (e.g. a Volt-driven
 * bootstrap) can reuse them without duplicating the wire-data → app-data
 * conversion.
 */

/**
 * Picks the active cloudId for this request. Prefers the caller's URL-derived
 * hint (Relay's `queryRef.variables.context.cloudId`); falls back to the first
 * entry in `cloudIds`; finally `null`.
 */
export function deriveContextCloudId(urlCloudIdHint: string | undefined, cloudIds: readonly string[]): string | null {
	return urlCloudIdHint ?? cloudIds[0] ?? null;
}
